(function () {
  class FireballIntro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;
      this.visible = false;

      this._pressStartBox = undefined;

      this._baseName = "";
      this._anims = [];
    }

    ///////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    ///////////////////////////////////////////////
    onLayoutComplete() {
      this._baseName = "slotContainer:fireballIntroPopup:fireballIntro";
      this._pressStartBox = resourceManager.get(
        this._baseName + ":pressStartColourBox"
      );

      this._multiplier = resourceManager.get(
        `${this._baseName}:fireLinkEntryGateway:blazingMultiplierForIntro:blazingMultiplier:value`
      );

      this._clickToContinue = resourceManager.get(
        `slotContainer:fireballIntroPopup:fireballContinue`
      );

      this._clickToContinue.visible = false;

      this._clickToContinue.mousedown = this._clickToContinue.touchstart =
        this.closeClickToContinue.bind(this);

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      for (let i = 0; i < 4; i++) {
        let anim = resourceManager.get(
          this._baseName + ":frameLightningAnim" + i
        );
        anim.gotoAndStop(0);
        anim.visible = false;

        this._anims.push(anim);
      }
    }

    ///////////////////////////////////////////////
    setup() {
      resourceManager.get(this._baseName).visible = true;

      // wait for click - anywhere on screen
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    showContinue(callback) {
      this._continueCallback = callback;
      this._clickToContinue.visible = true;
      this._clickToContinue.alpha = 1;
      this._clickToContinue.interactive = true;
      this._clickToContinue.mousedown = this._clickToContinue.touchstart =
        this.closeClickToContinue.bind(this);
    }

    closeClickToContinue() {
      this._clickToContinue.visible = false;
      this._clickToContinue.alpha = 0;
      this._clickToContinue.interactive = false;
      this._clickToContinue.mousedown = this._clickToContinue.touchstart =
        undefined;
      this._continueCallback();
    }

    ///////////////////////////////////////////////
    showIntro(callback) {
      this._multiplier.setText(`X${gameController.currentBlazingMultiplier}`);

      this.setup();
      this._callback = callback;

      resourceManager.get("fireballLinkIntroDim").visible = true;

      for (let i = 0; i < 4; i++) {
        const anim = this._anims[i];
        anim.gotoAndPlay(0);
        anim.visible = true;
        anim.onComplete = function () {
          anim.visible = false;
        };
      }
      gameData.musicManager.fadeOutAllMusic();
      gameData.musicManager.fadeInFireballMusic();
    }

    ///////////////////////////////////////////////
    closeDialog() {
      //gameData.musicManager.fadeOutPopUpMusic();

      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      resourceManager.get(this._baseName).visible = false;
      resourceManager.get("fireballLinkIntroDim").visible = false;
      this._callback();
    }
  }

  ///////////////////////////////////////////////
  let fireballIntroCreator = function (json) {
    return new FireballIntro();
  };

  ///////////////////////////////////////////////
  let fireballIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  ///////////////////////////////////////////////
  let fireballIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FireballIntro",
    fireballIntroCreator,
    fireballIntroInitialiser,
    fireballIntroFilesRequired
  );
})();
